const getDawaIdFromkvhxUrl = (kvhxUrl: string): string => {
    return kvhxUrl.split('/').pop() ?? '';
};

const getAddressStreetAndNumber = (address: string | undefined): string => {
    return address !== undefined ? address.split(',')[0] : '';
};

export { getDawaIdFromkvhxUrl, getAddressStreetAndNumber };
